var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showPriceDisclaimer)?_c('p',{staticClass:"cz2__disclaimer"},[_vm._v(" "+_vm._s(_vm.$t('PRICE_DISCLAIMER'))+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }